import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ConfigProvider, Button, Space, Card, Alert } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import './styles/globals.css';

// 导入认证Provider
import { AuthProvider } from './contexts/AuthContext';

// 导入页面组件
import HomePage from './pages/index';
import ProteinPage from './pages/protein/index';
import AntibodyPage from './pages/antibody/index';
import SequencePage from './pages/sequence/index';
import StructureRoutes from './pages/structure/routes';
import MolecularInteractionPage from './pages/interaction/index';
import RNAhybridPage from './pages/interaction/rnahybrid';
import ProdigyPage from './pages/interaction/prodigy';
import ZdockAsyncPage from './pages/interaction/zdock_async';
import MEGADOCKAsyncPage from './pages/interaction/megadock_async';
import EquiDockAsyncPage from './pages/interaction/equidock_async';
import MolecularCloningPage from './pages/cloning/index';
import SangerAnalysisPage from './pages/cloning/sanger';
import PrimerDesignPage from './pages/cloning/primer';
import PlasmidConstructionPage from './pages/cloning/plasmid';
import EnzymeAnalysisPage from './pages/cloning/enzyme';
import GeneSynthesisPage from './pages/cloning/gene-synthesis';
import BioDatabasePage from './pages/bio_db/index';
import StructureAnalysisPage from './pages/structure-analysis/index';
import AntibodySequencePage from './pages/antibody/sequence';
import AntibodyEpitopePage from './pages/antibody/epitope';
import AntibodyStructurePage from './pages/antibody/structure';
import PropermabPage from './pages/antibody/propermab';
import AntibodyHumanizationPage from './pages/antibody/humanization';
import AntibodyViscosityPage from './pages/antibody/viscosity';
import AdminPage from './pages/admin/index';

// 导入认证页面
import LoginPage from './pages/auth/LoginPage';
import MagicLinkCallback from './pages/auth/MagicLinkCallback';
import ProfilePage from './pages/auth/ProfilePage';
import SidebarLayout from './layouts/SidebarLayout';
import AuthGuard from './components/auth/AuthGuard';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Routes>
        {/* 认证相关页面不使用布局 */}
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/verify" element={<MagicLinkCallback />} />
        <Route path="/auth/callback" element={<MagicLinkCallback />} /> 
        
        {/* 使用AuthGuard和SidebarLayout包裹的受保护页面 */}
        <Route path="/" element={<AuthGuard><SidebarLayout><HomePage /></SidebarLayout></AuthGuard>} />
        <Route path="/auth/profile" element={<AuthGuard><SidebarLayout><ProfilePage /></SidebarLayout></AuthGuard>} />
        <Route path="/protein/*" element={<AuthGuard><SidebarLayout><ProteinPage /></SidebarLayout></AuthGuard>} />
        <Route path="/antibody" element={<AuthGuard><SidebarLayout><AntibodyPage /></SidebarLayout></AuthGuard>} />
        <Route path="/antibody/sequence" element={<AuthGuard><SidebarLayout><AntibodySequencePage /></SidebarLayout></AuthGuard>} />
        <Route path="/antibody/epitope" element={<AuthGuard><SidebarLayout><AntibodyEpitopePage /></SidebarLayout></AuthGuard>} />
        <Route path="/antibody/structure" element={<AuthGuard><SidebarLayout><AntibodyStructurePage /></SidebarLayout></AuthGuard>} />
        <Route path="/antibody/propermab" element={<AuthGuard><SidebarLayout><PropermabPage /></SidebarLayout></AuthGuard>} />
        <Route path="/sequence/*" element={<AuthGuard><SidebarLayout><SequencePage /></SidebarLayout></AuthGuard>} />
        {/* 数据可视化页面 - 已禁用，内部使用时取消注释 */}
        {/* <Route path="/structure-analysis" element={<AuthGuard><SidebarLayout><StructureAnalysisPage /></SidebarLayout></AuthGuard>} /> */}
        <Route path="/structure/*" element={<AuthGuard><SidebarLayout><StructureRoutes /></SidebarLayout></AuthGuard>} />
        <Route path="/interaction" element={<AuthGuard><SidebarLayout><MolecularInteractionPage /></SidebarLayout></AuthGuard>} />
        <Route path="/interaction/rnahybrid" element={<AuthGuard><SidebarLayout><RNAhybridPage /></SidebarLayout></AuthGuard>} />
        <Route path="/interaction/prodigy" element={<AuthGuard><SidebarLayout><ProdigyPage /></SidebarLayout></AuthGuard>} />
        {/* ZDOCK - 版权限制，已禁用，内部使用时取消注释 */}
        {/* <Route path="/interaction/zdock" element={<AuthGuard><SidebarLayout><ZdockAsyncPage /></SidebarLayout></AuthGuard>} /> */}
        {/* MEGADOCK - 版权限制，已禁用，内部使用时取消注释 */}
        {/* <Route path="/interaction/megadock" element={<AuthGuard><SidebarLayout><MEGADOCKAsyncPage /></SidebarLayout></AuthGuard>} /> */}
        <Route path="/interaction/equidock" element={<AuthGuard><SidebarLayout><EquiDockAsyncPage /></SidebarLayout></AuthGuard>} />
        <Route path="/cloning" element={<AuthGuard><SidebarLayout><MolecularCloningPage /></SidebarLayout></AuthGuard>} />
        <Route path="/cloning/sanger" element={<AuthGuard><SidebarLayout><SangerAnalysisPage /></SidebarLayout></AuthGuard>} />
        <Route path="/cloning/primer" element={<AuthGuard><SidebarLayout><PrimerDesignPage /></SidebarLayout></AuthGuard>} />
        <Route path="/cloning/plasmid" element={<AuthGuard><SidebarLayout><PlasmidConstructionPage /></SidebarLayout></AuthGuard>} />
        <Route path="/cloning/enzyme" element={<AuthGuard><SidebarLayout><EnzymeAnalysisPage /></SidebarLayout></AuthGuard>} />
        <Route path="/cloning/gene-synthesis" element={<AuthGuard><SidebarLayout><GeneSynthesisPage /></SidebarLayout></AuthGuard>} />
        {/* 生物数据库查询 - 已禁用，内部使用时取消注释 */}
        {/* <Route path="/bio_db/*" element={<AuthGuard><SidebarLayout><BioDatabasePage /></SidebarLayout></AuthGuard>} /> */}
        <Route path="/antibody/humanization" element={<AuthGuard><SidebarLayout><AntibodyHumanizationPage /></SidebarLayout></AuthGuard>} />
        <Route path="/antibody/viscosity" element={<AuthGuard><SidebarLayout><AntibodyViscosityPage /></SidebarLayout></AuthGuard>} />
        <Route path="/admin/*" element={<AuthGuard><AdminPage /></AuthGuard>} />
        </Routes>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;